(function() {
  const initSlider = () => {
    const sliders = document.querySelectorAll('.js-shop-the-look-slider');

    sliders.forEach((slider) => {
      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 8,
        watchSlidesProgress: true,
        speed: 500,
        navigation: {
          nextEl: slider.querySelector('.swiper-button-next'),
          prevEl: slider.querySelector('.swiper-button-prev'),
        },
      });
    });
  };

  const initSection = () => {
    initSlider();
  };

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSection);
  } else {
    initSection();
  }

  // Re-initialize on Shopify section load (Theme Editor)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.js-shop-the-look-slider')) {
      initSlider();
    }
  });
})();
